import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { hookInterfaceSchema } from '../models/hookInterface.schema';
import { hookInterfaceListQuerySchema } from './list.schema';

export type HookInterfaceListQuery = Partial<{
  name: string;
  hook: ID;
  type: string;
  canInvoke: boolean;
}> &
  PaginationQuery;

export const list = (query: HookInterfaceListQuery) => {
  return {
    endpoint: `/hook_interfaces`,
    method: 'GET',
    responseSchema: listResponse(hookInterfaceSchema),
    query: { ...query, includeTotal: true },
    querySchema: hookInterfaceListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
